import React, { useContext } from "react";
import ShortcutMenuWrapper from "../ShortcutMenuWrapper";
import UserMenuIcon from "assets/menus/master-maintenance/um-user.svg";
import UserRoleMenuIcon from "assets/menus/master-maintenance/um-user-role.svg";
import UserManagementMenuIcon from "assets/menus/master-maintenance/user-management.svg";
import { canAccess } from "@app/utils/permissionUtils";
import { RootState } from "@app/store/store";
import { useSelector } from "react-redux";
import { VariantContext } from "@app/variant"; // 👈 import your variant context

export const UserManagementMenu: React.FC = () => {
  const state = useSelector((s: RootState) => s);
  const { id } = useContext(VariantContext); // "control" | "user"


  if (id === "control") {
    return (
      <ShortcutMenuWrapper
        title="shortcutMenus.userManagement.title"
        icon={UserManagementMenuIcon}
        menus={[
          {
            title: "shortcutMenus.userManagement.users",
            icon: UserMenuIcon,
            url: "/users",
            categoryIcon: UserManagementMenuIcon,
            show: canAccess(state, "admin.manage.user"),
          },
          {
            title: "shortcutMenus.userManagement.endUsers",
            icon: UserMenuIcon,
            url: "/endUsers",
            categoryIcon: UserManagementMenuIcon,
            show: canAccess(state, "endUser.manage.user"),
          },
          {
            title: "shortcutMenus.userManagement.userRoles",
            icon: UserRoleMenuIcon,
            url: "/user-roles",
            categoryIcon: UserManagementMenuIcon,
            show: canAccess(state, "admin.manage.user-role"),
          },
        ]}
      />
    );
  }

  if (id === "user") {
    return (
      <ShortcutMenuWrapper
        title="shortcutMenus.userManagement.title"
        icon={UserManagementMenuIcon}
        menus={[
          // {
          //   title: "shortcutMenus.userManagement.users",
          //   icon: UserMenuIcon,
          //   url: "/users",
          //   categoryIcon: UserManagementMenuIcon,
          //   show: canAccess(state, "endUser.manage.user"),
          // },
          //   {
          //   title: "shortcutMenus.userManagement.userRoles",
          //   icon: UserRoleMenuIcon,
          //   url: "/user-roles",
          //   categoryIcon: UserManagementMenuIcon,
          //   show: canAccess(state, "endUser.manage.user-role"),
          // },
        ]}
      />
    );
  }

  return null;
};
